import axios from '@/libs/axios'

export default {
  getOrganizationInfo: () => axios.get('/public/organization'),
  getOrganizationConfig: () => axios.get('/organization/config'),
}
